import React from 'react'
import { useSelector } from 'react-redux'
import USTemplateDefault from 'src/components/template/us'
import { selectParams } from 'src/modules/reducers/params'
import { commonSubtitleText, commonTitleText } from 'src/modules/utils/constants'

export default (props) => {
  const params = useSelector(selectParams)

  return (
    <USTemplateDefault
      location={props.location}
      lang="en"
      market="us"
      offerBanner={
        params?.offer ? (
          <>
            Enjoy an exclusive offer with your stay: <br />
            Get 20% off your first month of Fubo.
          </>
        ) : null
      }
      title={commonTitleText.streamLiveTVSports}
      subtitle={commonSubtitleText.onAnyDevice}
      showRSN={true}
    />
  )
}
